import MappingBuilderModel from "~/models/tracked/mappingBuilderModel";
import Guid from "~/helpers/guid";
import {
  IMappingRelationIdentifier,
  IMappingRelationIdentifierCreateOpts,
  IModelMapping
} from "~/interfaces/mappingInterfaces";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import ObjectModel from "~/models/objectModel";
import MappingOrigin from "~/models/mapping/mappingOrigin";
import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import {RelationType} from "~/models/relationType";
import MappingOriginOptionObjectModelRelation from "~/models/mapping/mappingOriginOptionObjectModelRelation";
import {BooleanHelper} from "~/helpers/booleanHelper";

export default class RelationIdentifier extends MappingBuilderModel implements IMappingRelationIdentifier {
  ORIGIN_TYPE: 'relation' = 'relation'
  relation_client_id: string
  model_client_id: string
  inverse_relation: boolean

  constructor(parent: MappingOrigin | ModelMappingOrigin | IModelMapping) {
    super()
    this.parent = parent
    this._nameInParent = 'relation_identifiers'
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('inverse_relation', false);
  }

  get rootName(): string {
    return this._nameInParent
  }

  /**
   * This allows the property to be dynamic
   * RelationIdentifier is the child of MappingOrigin as 'relation_identifiers'
   * and of ModelMapping as 'destination_root_relation_identifier'
   */
  get isCollectionRoot(): boolean {
    if (BooleanHelper.isStrictBoolean(this._isCollectionRoot)) {
      return this._isCollectionRoot
    } else {
      return this._isCollectionRoot = this.parent.EMBEDDED_MODELS[this.rootName].relationType !== RelationType.singleObject;
    }
  }

  get relation(): ObjectModelRelation {
    return ObjectModelRelation.repo.findBy(r => r.client_id === this.relation_client_id)
  }

  get model(): ObjectModel {
    const x = !(ObjectModel.repo.findBy(m => m.client_id === this.model_client_id) instanceof ObjectModel)
    return ObjectModel.repo.findBy(m => m.client_id === this.model_client_id)
  }

  get compositeId(): string {
    return this.relation_client_id + ';' + this.model_client_id +`;inverse:${this.inverse_relation}`
  }

  get title(): string {
    if (!this.model) return null
    return `${this.labelTitle} (${this.modelTitle})`
  }

  get modelTitle(): string {
    if (!this.model) return null
    return this.model.title
  }

  get labelTitle(): string {
    if (!this.relation) return null
    return this.inverse_relation ? this.relation.label_title : this.relation.inverse_label_title
  }

  isEqual(other: IMappingRelationIdentifierCreateOpts | MappingOriginOptionObjectModelRelation): boolean {
    if (other instanceof MappingOriginOptionObjectModelRelation) {
      return this.relation_client_id === other.origin.client_id &&
        this.model_client_id === other.model.client_id &&
        this.inverse_relation === other.inverse_relation
    } else {
      return this.relation_client_id === other.relation_client_id &&
        this.model_client_id === other.model_client_id &&
        this.inverse_relation === other.inverse_relation
    }
  }
}